import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  private static readonly SELECTED_TENANT_KEY = 'session.selectedTenantId';

  constructor() {}

  /**
   * Get the currently selected tenant ID.
   * @returns The tenant ID or null if none is selected.
   */
  public getSelectedTenantId(): string {
    return localStorage.getItem(TenantService.SELECTED_TENANT_KEY);
  }

  /**
   * Set the selected tenant ID.
   * @param tenantId The tenant ID to set.
   */
  public setSelectedTenant(tenantId: string): void {
    localStorage.setItem(TenantService.SELECTED_TENANT_KEY, tenantId);
  }

  /**
   * Clear the selected tenant ID.
   */
  public clearSelectedTenantId(): void {
    localStorage.removeItem(TenantService.SELECTED_TENANT_KEY);
  }

  /**
   * Check if a tenant is selected.
   * @returns true if a tenant is selected, false otherwise.
   */
  public hasTenantSelected(): boolean {
    return !!this.getSelectedTenantId();
  }

  /**
   * Validate that the selected tenant is still available to the user.
   * @param availableTenants The list of available tenants for the user
   * @returns true if the selected tenant is valid, false otherwise.
   */
  public isSelectedTenantValid(availableTenants: any[]): boolean {
    const selectedTenantId = this.getSelectedTenantId();
    if (!selectedTenantId) {
      return false;
    }

    return availableTenants.some((tenant) => tenant.id === selectedTenantId);
  }

  /**
   * Clear tenant selection when user logs out.
   */
  public clearTenantOnLogout(): void {
    this.clearSelectedTenantId();
  }
}
